<template>
  <div>
    <scroll-pane id="tags-view-container" class="tags-view-wrapper tags-view-container">
      <router-link
        v-for="tag in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="isActive(tag)?'active':''"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
      >
        <span>{{ tag.title }}</span>
        <span class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)"/>
      </router-link>
    </scroll-pane>
  </div>
</template>

<script>
import ScrollPane from "./ScrollPane";
import { mapState } from "vuex";

export default {
  components: { ScrollPane },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      visitedViews: "visitedViews"
    }),
  },

  methods: {
    isActive(route) {
      return route.path === this.$route.path;
    },
    closeSelectedTag(view) {
      this.$store.commit("deleteVisitedViews", view);
    },

  }
};
</script>

<style lang="scss" scoped>
.tags-view-container {
  height: 44px;
  width: 100%;
  margin-top: 12px;
  background: #fbfbfb;
  border-radius: 10px;
}

.tags-view-item {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  line-height: 26px;
  border: 1px solid #d8dce5;
  padding: 0 8px;
  margin-left: 8px;
  min-width: 80px;
  height: 28px;
  text-decoration: none;
  border-radius: 8px;
  font-size: 14px;
  font-family: Arial sans-serif;
  color: #999999;

  &.active {
    background: #75B8E6;
    color: #FBFBFB;
  }
}
</style>
